// TODO: Change this to use a datetime handling library
//  See https://jira.capraconsulting.no/browse/LCL-73
export function graphQlDateTimeToDate(value: DateTime): Date {
  const casted = value as unknown as DateTimeReal;
  return new Date(casted);
}

// Example value = '2020-01-11'
export function graphQlStringToLocalDate(value: string): LocalDate {
  const regExp = new RegExp(
    "^(?<fullyear>\\d{4})-(?<month>0[1-9]|1[0-2])-(?<mday>0[1-9]|[12][0-9]|3[01])",
  );

  if (regExp.test(value)) {
    return value as unknown as LocalDate;
  } else {
    throw new Error(`Invalid RFC3339 value: ${value}`);
  }
}
